import type { ICard } from "../../cardsSlice";

export const major14Card: ICard = {
    id: "major_14",
    arcana: "major",
    number: 14,
    suit: "major",
    court: "major",
    name: "Умеренность",
    nameEn: "Temperance",
    keywords: ["Гармония", "Баланс", "Исцеление"],
    symbolism: [
      "Ангел, переливающий воду из сосуда в сосуд",
      "Одна нога в воде, другая на земле",
      "Радуга, ирисы, солнечный диск"
    ],
    symbolismInterpretation:
      "Соединение противоположностей, нахождение баланса и внутреннего равновесия",
    archetype: "Алхимия души, архетип интеграции и исцеления",
    psychology: "Период восстановления, интеграция опыта, умеренность",
    upright: {
      personality: "Спокойствие, терпимость, саморегуляция",
      relationships: "Примирение, восстановление доверия",
      work: "Гармонизация процессов, объединение ресурсов",
      spirituality: "Внутреннее слияние, умеренность как путь",
      examples: ["Плавное движение вперёд", "Поиск баланса", "Целительный процесс"]
    },
    reversed: {
      meaning: "Дисгармония, крайности, неустойчивость",
      nuances: "Потеря внутреннего центра, тревожность"
    },
    associations: ["Поток", "Смешение", "Целительство", "Баланс"],
    combinations: ["С Силой — мягкость и устойчивость", "С Дьяволом — борьба с дисбалансом и искушением"],
    readingTips: ["Избегать крайностей", "Искать срединный путь"],
    selfQuestions: ["Где мне не хватает гармонии?", "Что я могу примирить в себе?"]
  };


